import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  type User,
  type UserCredential
} from "firebase/auth";
import { auth } from "./firebase.js";

export type FirebaseUser = User;

export function login(email: string, senha: string): Promise<UserCredential> {
  return signInWithEmailAndPassword(auth, email, senha);
}

export function logout(): Promise<void> {
  return signOut(auth);
}

/** Fonte de verdade do estado de login (currentUser pode ser null durante o init). */
export function observeAuth(callback: (user: User | null) => void): () => void {
  return onAuthStateChanged(auth, callback);
}

/** ID token fresco (getIdToken reusa o cache válido e renova quando expirado). */
export async function getIdToken(): Promise<string | null> {
  const user = auth.currentUser;
  return user !== null ? user.getIdToken() : null;
}
